import { render, staticRenderFns } from "./list-counts.vue?vue&type=template&id=3247c1be&scoped=true"
import script from "./list-counts.vue?vue&type=script&lang=ts"
export * from "./list-counts.vue?vue&type=script&lang=ts"
import style0 from "./list-counts.vue?vue&type=style&index=0&id=3247c1be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3247c1be",
  null
  
)

export default component.exports